export function VIFSequenceLine(cjs, an) {
  var p; // shortcut to reference prototypes
  var lib = {};
  var ss = {};
  var img = {};
  lib.ssMetadata = [];

  (lib.AnMovieClip = function () {
    this.actionFrames = [];
    this.ignorePause = false;
    this.gotoAndPlay = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
    };
    this.play = function () {
      cjs.MovieClip.prototype.play.call(this);
    };
    this.gotoAndStop = function (positionOrLabel) {
      cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
    };
    this.stop = function () {
      cjs.MovieClip.prototype.stop.call(this);
    };
  }).prototype = p = new cjs.MovieClip();
  // symbols:
  // helper functions:

  function mc_symbol_clone() {
    var clone = this._cloneProps(
      new this.constructor(
        this.mode,
        this.startPosition,
        this.loop,
        this.reversed,
      ),
    );
    clone.gotoAndStop(this.currentFrame);
    clone.paused = this.paused;
    clone.framerate = this.framerate;
    return clone;
  }

  function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
    var prototype = cjs.extend(symbol, cjs.MovieClip);
    prototype.clone = mc_symbol_clone;
    prototype.nominalBounds = nominalBounds;
    prototype.frameBounds = frameBounds;
    return prototype;
  }

  (lib.currentModuleIndicator = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1),
    );

    // on
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f()
      .s('#D2D966')
      .ss(2)
      .p(
        'ACiAAQAABEgvAvQgwAwhDAAQhCAAgwgwQgvgvAAhEQAAhCAvgwQAwgwBCAAQBDAAAwAwQAvAwAABCg',
      );
    this.shape.setTransform(0.025, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FFFFFF')
      .s()
      .p(
        'AhyBzQgvgvAAhEQAAhCAvgwQAwgwBCAAQBDAAAwAwQAvAwAABCQAABEgvAvQgwAwhDgBQhCABgwgwg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .to({ state: [] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 36.5);

  (lib.redModule23 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgUBBQgHgCgHgDIAAgXQANAIANAAQAJAAAEgFQAFgEAAgJQAAgKgGgEQgFgFgMAAIgHAAIAAgTIAHAAQALAAAFgFQAGgFAAgJQAAgOgNAAQgGAAgFACQgFACgFAEIgJgRQAIgHAIgCQAIgDAKAAQAPAAAJAIQAJAJAAAQQAAAKgGAIQgFAIgLAEIAAAAQAYAEAAAaQAAASgLAKQgKAKgTAAQgIAAgHgBg',
      );
    this.shape_2.setTransform(4.125, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_3.setTransform(-4.45, 33.075);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgUBBQgHgCgHgDIAAgXQANAIANAAQAJAAAEgFQAFgEAAgJQAAgKgGgEQgFgFgMAAIgHAAIAAgTIAHAAQALAAAFgFQAGgFAAgJQAAgOgNAAQgGAAgFACQgFACgFAEIgJgRQAIgHAIgCQAIgDAKAAQAPAAAJAIQAJAJAAAQQAAAKgGAIQgFAIgLAEIAAAAQAYAEAAAaQAAASgLAKQgKAKgTAAQgIAAgHgBg',
      );
    this.shape_4.setTransform(4.125, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_5.setTransform(-4.45, 33.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule21 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_2.setTransform(3.65, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_3.setTransform(-4.45, 33.075);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_4.setTransform(3.65, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_5.setTransform(-4.45, 33.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule19 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgVBCIgIgCIAAgUQAHACAIAAQAOAAAGgLQAHgLAAgTIgBAAQgGAPgNAAQgOAAgHgMQgHgKAAgTQAAgNAEgKQAEgKAIgFQAIgGALAAQARAAAJAPQAKAOAAAbQAAAPgDAOQgCAOgGAKQgGAKgJAGQgJAGgNAAIgJAAgAgIgmQgDAFAAAMQAAAVALAAQAEAAACgDIAEgHIABgIIAAgIIgCgIIgDgHQgDgDgDAAQgFAAgDAGg',
      );
    this.shape_2.setTransform(4.175, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgVBCIgIgCIAAgUQAHACAIAAQAOAAAGgLQAHgLAAgTIgBAAQgGAPgNAAQgOAAgHgMQgHgKAAgTQAAgNAEgKQAEgKAIgFQAIgGALAAQARAAAJAPQAKAOAAAbQAAAPgDAOQgCAOgGAKQgGAKgJAGQgJAGgNAAIgJAAgAgIgmQgDAFAAAMQAAAVALAAQAEAAACgDIAEgHIABgIIAAgIIgCgIIgDgHQgDgDgDAAQgFAAgDAGg',
      );
    this.shape_4.setTransform(4.175, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule18 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgaA5QgKgJAAgRQAAgKAGgJQAEgIAKgGQgIgHgEgIQgEgIAAgJQAAgPAJgIQAJgIAOAAQARAAAIAIQAJAIAAAPQgBAKgEAIQgEAIgKAGQALAGAGAIQAEAIAAALQAAAQgJAKQgKAJgRAAQgRAAgJgJgAgKATQgCAFAAAHQAAAHADAEQADAFAGAAQAHAAADgFQAEgEAAgHQAAgFgDgFQgDgFgGgFIgCgCQgGAFgEAFgAgHgqQgCADAAAHQAAAFACAFQADAEAEAEQAGgFACgEQADgEAAgFQAAgHgDgDQgDgEgFAAQgDAAgEAEg',
      );
    this.shape_2.setTransform(4.2, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgaA5QgKgJAAgRQAAgKAGgJQAEgIAKgGQgIgHgEgIQgEgIAAgJQAAgPAJgIQAJgIAOAAQARAAAIAIQAJAIAAAPQgBAKgEAIQgEAIgKAGQALAGAGAIQAEAIAAALQAAAQgJAKQgKAJgRAAQgRAAgJgJgAgKATQgCAFAAAHQAAAHADAEQADAFAGAAQAHAAADgFQAEgEAAgHQAAgFgDgFQgDgFgGgFIgCgCQgGAFgEAFgAgHgqQgCADAAAHQAAAFACAFQADAEAEAEQAGgFACgEQADgEAAgFQAAgHgDgDQgDgEgFAAQgDAAgEAEg',
      );
    this.shape_4.setTransform(4.2, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule17 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p('AgaBAIAlhqIguAAIAAgVIBHAAIAAAQIgkBvg');
    this.shape_2.setTransform(4.2, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FAE1E0')
      .s()
      .p('AgaBAIAlhqIguAAIAAgVIBHAAIAAAQIgkBvg');
    this.shape_4.setTransform(4.2, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule16 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgZAzQgKgPAAgaQAAgPACgOQADgOAGgKQAFgKAKgGQAIgGAOAAQAJAAAHACIAAAUIgHgBIgHgBQgNAAgHAKQgGAKgBAVIAAAAQAHgPANAAQANAAAIAMQAHAKAAATQAAANgEAKQgFAKgHAFQgHAGgMAAQgQAAgKgPgAgHAGQgEAFAAAIQAAAGACAGQABAGADAEQACAEAEAAQAEAAAEgGQACgFABgMQAAgVgLAAQgFAAgDAFg',
      );
    this.shape_2.setTransform(4.25, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgZAzQgKgPAAgaQAAgPACgOQADgOAGgKQAFgKAKgGQAIgGAOAAQAJAAAHACIAAAUIgHgBIgHgBQgNAAgHAKQgGAKgBAVIAAAAQAHgPANAAQANAAAIAMQAHAKAAATQAAANgEAKQgFAKgHAFQgHAGgMAAQgQAAgKgPgAgHAGQgEAFAAAIQAAAGACAGQABAGADAEQACAEAEAAQAEAAAEgGQACgFABgMQAAgVgLAAQgFAAgDAFg',
      );
    this.shape_4.setTransform(4.25, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule14 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AADBAIAAgaIgqAAIAAgTIAqhSIAYAAIAABSIANAAIAAATIgNAAIAAAagAAAgXIgCAHIgRAjIAWAAIAAgdIAAgGIAAgIIAAgGIgBAAIgCAHg',
      );
    this.shape_2.setTransform(4.275, 33.15);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AADBAIAAgaIgqAAIAAgTIAqhSIAYAAIAABSIANAAIAAATIgNAAIAAAagAAAgXIgCAHIgRAjIAWAAIAAgdIAAgGIAAgIIAAgGIgBAAIgCAHg',
      );
    this.shape_4.setTransform(4.275, 33.15);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule13 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgUBBQgHgCgHgDIAAgXQANAIANAAQAJAAAEgFQAFgEAAgJQAAgKgGgEQgFgFgMAAIgHAAIAAgTIAHAAQALAAAFgFQAGgFAAgJQAAgOgNAAQgGAAgFACQgFACgFAEIgJgRQAIgHAIgCQAIgDAKAAQAPAAAJAIQAJAJAAAQQAAAKgGAIQgFAIgLAEIAAAAQAYAEAAAaQAAASgLAKQgKAKgTAAQgIAAgHgBg',
      );
    this.shape_2.setTransform(4.125, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgUBBQgHgCgHgDIAAgXQANAIANAAQAJAAAEgFQAFgEAAgJQAAgKgGgEQgFgFgMAAIgHAAIAAgTIAHAAQALAAAFgFQAGgFAAgJQAAgOgNAAQgGAAgFACQgFACgFAEIgJgRQAIgHAIgCQAIgDAKAAQAPAAAJAIQAJAJAAAQQAAAKgGAIQgFAIgLAEIAAAAQAYAEAAAaQAAASgLAKQgKAKgTAAQgIAAgHgBg',
      );
    this.shape_4.setTransform(4.125, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule12 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgEgEgFAAQgFAAgFADQgEACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAFAIAAAKQAAAJgDAIQgCAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_2.setTransform(4, 33.075);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgEgEgFAAQgFAAgFADQgEACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAFAIAAAKQAAAJgDAIQgCAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_4.setTransform(4, 33.075);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule09 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgVBCIgIgCIAAgUQAHACAIAAQAOAAAGgLQAHgLAAgTIgBAAQgGAPgNAAQgOAAgHgMQgHgKAAgTQAAgNAEgKQAEgKAIgFQAIgGALAAQARAAAJAPQAKAOAAAbQAAAPgDAOQgCAOgGAKQgGAKgJAGQgJAGgNAAIgJAAgAgIgmQgDAFAAAMQAAAVALAAQAEAAACgDIAEgHIABgIIAAgIIgCgIIgDgHQgDgDgDAAQgFAAgDAGg',
      );
    this.shape_2.setTransform(-0.075, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgVBCIgIgCIAAgUQAHACAIAAQAOAAAGgLQAHgLAAgTIgBAAQgGAPgNAAQgOAAgHgMQgHgKAAgTQAAgNAEgKQAEgKAIgFQAIgGALAAQARAAAJAPQAKAOAAAbQAAAPgDAOQgCAOgGAKQgGAKgJAGQgJAGgNAAIgJAAgAgIgmQgDAFAAAMQAAAVALAAQAEAAACgDIAEgHIABgIIAAgIIgCgIIgDgHQgDgDgDAAQgFAAgDAGg',
      );
    this.shape_3.setTransform(-0.075, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule08 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgaA5QgJgJAAgRQAAgKAEgJQAFgIAKgGQgIgHgEgIQgEgIAAgJQAAgPAJgIQAJgIAPAAQAQAAAIAIQAJAIAAAPQAAAKgFAIQgFAIgJAGQALAGAFAIQAGAIgBALQAAAQgJAKQgKAJgQAAQgRAAgKgJgAgJATQgDAFAAAHQAAAHADAEQAEAFAFAAQAHAAADgFQADgEAAgHQAAgFgCgFQgDgFgGgFIgCgCQgHAFgCAFgAgHgqQgCADAAAHQAAAFACAFQADAEAEAEQAGgFADgEQACgEAAgFQAAgHgDgDQgDgEgEAAQgEAAgEAEg',
      );
    this.shape_2.setTransform(-0.05, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgaA5QgJgJAAgRQAAgKAEgJQAFgIAKgGQgIgHgEgIQgEgIAAgJQAAgPAJgIQAJgIAPAAQAQAAAIAIQAJAIAAAPQAAAKgFAIQgFAIgJAGQALAGAFAIQAGAIgBALQAAAQgJAKQgKAJgQAAQgRAAgKgJgAgJATQgDAFAAAHQAAAHADAEQAEAFAFAAQAHAAADgFQADgEAAgHQAAgFgCgFQgDgFgGgFIgCgCQgHAFgCAFgAgHgqQgCADAAAHQAAAFACAFQADAEAEAEQAGgFADgEQACgEAAgFQAAgHgDgDQgDgEgEAAQgEAAgEAEg',
      );
    this.shape_3.setTransform(-0.05, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule07 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p('AgaBAIAlhqIguAAIAAgVIBHAAIAAAQIgkBvg');
    this.shape_2.setTransform(-0.05, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FAE1E0')
      .s()
      .p('AgaBAIAlhqIguAAIAAgVIBHAAIAAAQIgkBvg');
    this.shape_3.setTransform(-0.05, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule06 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgZAzQgKgPAAgaQAAgPADgOQACgOAGgKQAFgKAJgGQAJgGAOAAQAJAAAIACIAAAUIgHgBIgIgBQgOAAgFAKQgIAKAAAVIAAAAQAHgPAMAAQAOAAAIAMQAHAKAAATQAAANgEAKQgFAKgHAFQgHAGgMAAQgQAAgKgPgAgHAGQgDAFgBAIQABAGABAGQABAGADAEQADAEADAAQAEAAADgGQAEgFAAgMQgBgVgKAAQgFAAgDAFg',
      );
    this.shape_2.setTransform(0, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgZAzQgKgPAAgaQAAgPADgOQACgOAGgKQAFgKAJgGQAJgGAOAAQAJAAAIACIAAAUIgHgBIgIgBQgOAAgFAKQgIAKAAAVIAAAAQAHgPAMAAQAOAAAIAMQAHAKAAATQAAANgEAKQgFAKgHAFQgHAGgMAAQgQAAgKgPgAgHAGQgDAFgBAIQABAGABAGQABAGADAEQADAEADAAQAEAAADgGQAEgFAAgMQgBgVgKAAQgFAAgDAFg',
      );
    this.shape_3.setTransform(0, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule05 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AghA7IAAgXQAGAEAGACQAHACAGAAQAIAAAFgGQAEgGAAgKQAAgUgRAAQgHAAgIADIgIgGIADg/IA3AAIAAAVIgiAAIgCAbIAHgCIAFAAQAJAAAHAFQAHAFAEAIQAEAJAAAMQAAAVgKALQgLAMgUAAQgPAAgLgGg',
      );
    this.shape_2.setTransform(0.025, 33.275);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AghA7IAAgXQAGAEAGACQAHACAGAAQAIAAAFgGQAEgGAAgKQAAgUgRAAQgHAAgIADIgIgGIADg/IA3AAIAAAVIgiAAIgCAbIAHgCIAFAAQAJAAAHAFQAHAFAEAIQAEAJAAAMQAAAVgKALQgLAMgUAAQgPAAgLgGg',
      );
    this.shape_3.setTransform(0.025, 33.275);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule04 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AADBAIAAgaIgqAAIAAgTIAqhSIAYAAIAABSIANAAIAAATIgNAAIAAAagAAAgXIgCAHIgRAjIAWAAIAAgdIAAgGIAAgIIAAgGIgBAAIgCAHg',
      );
    this.shape_2.setTransform(0.025, 33.15);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AADBAIAAgaIgqAAIAAgTIAqhSIAYAAIAABSIANAAIAAATIgNAAIAAAagAAAgXIgCAHIgRAjIAWAAIAAgdIAAgGIAAgIIAAgGIgBAAIgCAHg',
      );
    this.shape_3.setTransform(0.025, 33.15);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule03 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgUBBQgHgCgHgDIAAgXQANAIANAAQAJAAAEgFQAFgEAAgJQAAgKgGgEQgFgFgMAAIgHAAIAAgTIAHAAQALAAAFgFQAGgFAAgJQAAgOgNAAQgGAAgFACQgFACgFAEIgJgRQAIgHAIgCQAIgDAKAAQAPAAAJAIQAJAJAAAQQAAAKgGAIQgFAIgLAEIAAAAQAYAEAAAaQAAASgLAKQgKAKgTAAQgIAAgHgBg',
      );
    this.shape_2.setTransform(-0.125, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgUBBQgHgCgHgDIAAgXQANAIANAAQAJAAAEgFQAFgEAAgJQAAgKgGgEQgFgFgMAAIgHAAIAAgTIAHAAQALAAAFgFQAGgFAAgJQAAgOgNAAQgGAAgFACQgFACgFAEIgJgRQAIgHAIgCQAIgDAKAAQAPAAAJAIQAJAJAAAQQAAAKgGAIQgFAIgLAEIAAAAQAYAEAAAaQAAASgLAKQgKAKgTAAQgIAAgHgBg',
      );
    this.shape_3.setTransform(-0.125, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.redModule02 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#EA3C34')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // indicator
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgFADQgEACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAIAFAEAHQAFAIgBAKQAAAJgCAIQgBAHgGAIQgEAIgJALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_2.setTransform(-0.25, 33.075);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgFADQgEACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAIAFAEAHQAFAIgBAKQAAAJgCAIQgBAHgGAIQgEAIgJALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_3.setTransform(-0.25, 33.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.milestoneModule25 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // redDot
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AAAAnIgvAjIATg4IgxgiIA8AAIARg5IASA5IA8AAIgxAiIATA4g');
    this.shape.setTransform(0.025, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EA3C34')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg1AmglQAmgmA0AAQA1AAAmAmQAmAlAAA1QAAA1gmAmQglAmg2AAQg0AAgmgmg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg0AmgmQAmgmA0AAQA2AAAlAmQAmAmAAA0QAAA1gmAmQglAmg2AAQg1AAglgmg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_2 }, { t: this.shape }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AghA7IAAgXQAGAEAGACQAHACAGAAQAIAAAFgGQAEgGAAgKQAAgUgRAAQgHAAgIADIgIgGIADg/IA3AAIAAAVIgiAAIgCAbIAHgCIAFAAQAJAAAHAFQAHAFAEAIQAEAJAAAMQAAAVgKALQgLAMgUAAQgPAAgLgGg',
      );
    this.shape_3.setTransform(4.275, 33.275);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_4.setTransform(-4.45, 33.075);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AghA7IAAgXQAGAEAGACQAHACAGAAQAIAAAFgGQAEgGAAgKQAAgUgRAAQgHAAgIADIgIgGIADg/IA3AAIAAAVIgiAAIgCAbIAHgCIAFAAQAJAAAHAFQAHAFAEAIQAEAJAAAMQAAAVgKALQgLAMgUAAQgPAAgLgGg',
      );
    this.shape_5.setTransform(4.275, 33.275);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_6.setTransform(-4.45, 33.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.milestoneModule20 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // redDot
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AAAAnIgvAjIATg4IgxgiIA8AAIARg5IASA5IA8AAIgxAiIATA4g');
    this.shape.setTransform(0.025, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EA3C34')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg1AmglQAmgmA0AAQA1AAAmAmQAmAlAAA1QAAA1gmAmQglAmg2AAQg0AAgmgmg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg0AmgmQAmgmA0AAQA2AAAlAmQAmAmAAA0QAAA1gmAmQglAmg2AAQg1AAglgmg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_2 }, { t: this.shape }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgaAzQgIgQgBgjQABghAIgQQAJgQARAAQAjAAAABBQAAATgCAPQgDAPgIAJQgIAIgOAAQgRAAgJgPgAgIggQgCALAAAVQAAAXACALQACALAGAAQAGAAADgLQACgLAAgXQAAgVgCgLQgDgMgGAAQgFAAgDAMg',
      );
    this.shape_3.setTransform(4.2, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_4.setTransform(-4.45, 33.075);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgaAzQgIgQgBgjQABghAIgQQAJgQARAAQAjAAAABBQAAATgCAPQgDAPgIAJQgIAIgOAAQgRAAgJgPgAgIggQgCALAAAVQAAAXACALQACALAGAAQAGAAADgLQACgLAAgXQAAgVgCgLQgDgMgGAAQgFAAgDAMg',
      );
    this.shape_5.setTransform(4.2, 33.175);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_6.setTransform(-4.45, 33.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.milestoneModule15 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // redDot
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AAAAnIgvAjIATg4IgxgiIA8AAIARg5IASA5IA8AAIgxAiIATA4g');
    this.shape.setTransform(0.025, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EA3C34')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg1AmglQAmgmA0AAQA1AAAmAmQAmAlAAA1QAAA1gmAmQglAmg2AAQg0AAgmgmg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg0AmgmQAmgmA0AAQA2AAAlAmQAmAmAAA0QAAA1gmAmQglAmg2AAQg1AAglgmg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_2 }, { t: this.shape }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AghA7IAAgXQAGAEAGACQAHACAGAAQAIAAAFgGQAEgGAAgKQAAgUgRAAQgHAAgIADIgIgGIADg/IA3AAIAAAVIgiAAIgCAbIAHgCIAFAAQAJAAAHAFQAHAFAEAIQAEAJAAAMQAAAVgKALQgLAMgUAAQgPAAgLgGg',
      );
    this.shape_3.setTransform(4.275, 33.275);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_4.setTransform(-4.8, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AghA7IAAgXQAGAEAGACQAHACAGAAQAIAAAFgGQAEgGAAgKQAAgUgRAAQgHAAgIADIgIgGIADg/IA3AAIAAAVIgiAAIgCAbIAHgCIAFAAQAJAAAHAFQAHAFAEAIQAEAJAAAMQAAAVgKALQgLAMgUAAQgPAAgLgGg',
      );
    this.shape_5.setTransform(4.275, 33.275);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_6.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.milestoneModule14 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // redDot
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AAAAnIgvAjIATg4IgxgiIA8AAIARg5IASA5IA8AAIgxAiIATA4g');
    this.shape.setTransform(0.025, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EA3C34')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg1AmglQAmgmA0AAQA1AAAmAmQAmAlAAA1QAAA1gmAmQglAmg2AAQg0AAgmgmg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg0AmgmQAmgmA0AAQA2AAAlAmQAmAmAAA0QAAA1gmAmQglAmg2AAQg1AAglgmg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_2 }, { t: this.shape }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AADBAIAAgaIgqAAIAAgTIAqhSIAYAAIAABSIANAAIAAATIgNAAIAAAagAAAgXIgCAHIgRAjIAWAAIAAgdIAAgGIAAgIIAAgGIgBAAIgCAHg',
      );
    this.shape_3.setTransform(4.275, 33.15);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_4.setTransform(-4.8, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AADBAIAAgaIgqAAIAAgTIAqhSIAYAAIAABSIANAAIAAATIgNAAIAAAagAAAgXIgCAHIgRAjIAWAAIAAgdIAAgGIAAgIIAAgGIgBAAIgCAHg',
      );
    this.shape_5.setTransform(4.275, 33.15);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_6.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.milestoneModule12 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // redDot
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AAAAnIgvAjIATg4IgxgiIA8AAIARg5IASA5IA8AAIgxAiIATA4g');
    this.shape.setTransform(0.025, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EA3C34')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg1AmglQAmgmA0AAQA1AAAmAmQAmAlAAA1QAAA1gmAmQglAmg2AAQg0AAgmgmg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg0AmgmQAmgmA0AAQA2AAAlAmQAmAmAAA0QAAA1gmAmQglAmg2AAQg1AAglgmg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_2 }, { t: this.shape }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgEgEgFAAQgFAAgFADQgEACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAFAIAAAKQAAAJgDAIQgCAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_3.setTransform(4, 33.075);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_4.setTransform(-4.8, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgEgEgFAAQgFAAgFADQgEACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAFAIAAAKQAAAJgDAIQgCAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_5.setTransform(4, 33.075);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_6.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.milestoneModule11 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // redDot
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AAAAnIgvAjIATg4IgxgiIA8AAIARg5IASA5IA8AAIgxAiIATA4g');
    this.shape.setTransform(0.025, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EA3C34')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg1AmglQAmgmA0AAQA1AAAmAmQAmAlAAA1QAAA1gmAmQglAmg2AAQg0AAgmgmg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg0AmgmQAmgmA0AAQA2AAAlAmQAmAmAAA0QAAA1gmAmQglAmg2AAQg1AAglgmg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_2 }, { t: this.shape }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(3.65, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_4.setTransform(-4.8, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(3.65, 33.175);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_6.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.milestoneModule10 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // redDot
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#FFFFFF')
      .s()
      .p('AAAAnIgvAjIATg4IgxgiIA8AAIARg5IASA5IA8AAIgxAiIATA4g');
    this.shape.setTransform(0.025, 0);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#EA3C34')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg1AmglQAmgmA0AAQA1AAAmAmQAmAlAAA1QAAA1gmAmQglAmg2AAQg0AAgmgmg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#FAE1E1')
      .s()
      .p(
        'AhaBbQgmgmAAg1QAAg0AmgmQAmgmA0AAQA2AAAlAmQAmAmAAA0QAAA1gmAmQglAmg2AAQg1AAglgmg',
      );

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] })
        .to({ state: [{ t: this.shape_1 }, { t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_2 }, { t: this.shape }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#EA3C33')
      .s()
      .p(
        'AgaAzQgIgQgBgjQABghAIgQQAJgQARAAQAjAAAABBQAAATgCAPQgDAPgIAJQgIAIgOAAQgRAAgJgPgAgIggQgCALAAAVQAAAXACALQACALAGAAQAGAAADgLQACgLAAgXQAAgVgCgLQgDgMgGAAQgFAAgDAMg',
      );
    this.shape_3.setTransform(4.2, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#EA3C33')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_4.setTransform(-4.8, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#FAE1E0')
      .s()
      .p(
        'AgaAzQgIgQgBgjQABghAIgQQAJgQARAAQAjAAAABBQAAATgCAPQgDAPgIAJQgIAIgOAAQgRAAgJgPgAgIggQgCALAAAVQAAAXACALQACALAGAAQAGAAADgLQACgLAAgXQAAgVgCgLQgDgMgGAAQgFAAgDAMg',
      );
    this.shape_5.setTransform(4.2, 33.175);

    this.shape_6 = new cjs.Shape();
    this.shape_6.graphics
      .f('#FAE1E0')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_6.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] })
        .to({ state: [{ t: this.shape_4 }, { t: this.shape_3 }] }, 1)
        .to({ state: [{ t: this.shape_6 }, { t: this.shape_5 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule26 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgZAzQgKgPAAgaQAAgPACgOQADgOAGgKQAFgKAKgGQAIgGAOAAQAJAAAHACIAAAUIgHgBIgHgBQgNAAgHAKQgGAKgBAVIAAAAQAHgPANAAQANAAAIAMQAHAKAAATQAAANgEAKQgFAKgHAFQgHAGgMAAQgQAAgKgPgAgHAGQgEAFAAAIQAAAGACAGQABAGADAEQACAEAEAAQAEAAAEgGQACgFABgMQAAgVgLAAQgFAAgDAFg',
      );
    this.shape_2.setTransform(4.25, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_3.setTransform(-4.45, 33.075);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgZAzQgKgPAAgaQAAgPACgOQADgOAGgKQAFgKAKgGQAIgGAOAAQAJAAAHACIAAAUIgHgBIgHgBQgNAAgHAKQgGAKgBAVIAAAAQAHgPANAAQANAAAIAMQAHAKAAATQAAANgEAKQgFAKgHAFQgHAGgMAAQgQAAgKgPgAgHAGQgEAFAAAIQAAAGACAGQABAGADAEQACAEAEAAQAEAAAEgGQACgFABgMQAAgVgLAAQgFAAgDAFg',
      );
    this.shape_4.setTransform(4.25, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_5.setTransform(-4.45, 33.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule24 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AADBAIAAgaIgqAAIAAgTIAqhSIAYAAIAABSIANAAIAAATIgNAAIAAAagAAAgXIgCAHIgRAjIAWAAIAAgdIAAgGIAAgIIAAgGIgBAAIgCAHg',
      );
    this.shape_2.setTransform(4.275, 33.15);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_3.setTransform(-4.45, 33.075);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AADBAIAAgaIgqAAIAAgTIAqhSIAYAAIAABSIANAAIAAATIgNAAIAAAagAAAgXIgCAHIgRAjIAWAAIAAgdIAAgGIAAgIIAAgGIgBAAIgCAHg',
      );
    this.shape_4.setTransform(4.275, 33.15);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_5.setTransform(-4.45, 33.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule22 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgEgEgFAAQgFAAgFADQgEACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAFAIAAAKQAAAJgDAIQgCAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_2.setTransform(4, 33.075);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_3.setTransform(-4.45, 33.075);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgEgEgFAAQgFAAgFADQgEACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAFAIAAAKQAAAJgDAIQgCAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_4.setTransform(4, 33.075);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_5.setTransform(-4.45, 33.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule21 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_2.setTransform(3.65, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_3.setTransform(-4.45, 33.075);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_4.setTransform(3.65, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_5.setTransform(-4.45, 33.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule20 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgaAzQgIgQgBgjQABghAIgQQAJgQARAAQAjAAAABBQAAATgCAPQgDAPgIAJQgIAIgOAAQgRAAgJgPgAgIggQgCALAAAVQAAAXACALQACALAGAAQAGAAADgLQACgLAAgXQAAgVgCgLQgDgMgGAAQgFAAgDAMg',
      );
    this.shape_2.setTransform(4.2, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_3.setTransform(-4.45, 33.075);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgaAzQgIgQgBgjQABghAIgQQAJgQARAAQAjAAAABBQAAATgCAPQgDAPgIAJQgIAIgOAAQgRAAgJgPgAgIggQgCALAAAVQAAAXACALQACALAGAAQAGAAADgLQACgLAAgXQAAgVgCgLQgDgMgGAAQgFAAgDAMg',
      );
    this.shape_4.setTransform(4.2, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgEADQgFACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAEAIABAKQAAAJgCAIQgDAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_5.setTransform(-4.45, 33.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule19 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgVBCIgIgCIAAgUQAHACAIAAQAOAAAGgLQAHgLAAgTIgBAAQgGAPgNAAQgOAAgHgMQgHgKAAgTQAAgNAEgKQAEgKAIgFQAIgGALAAQARAAAJAPQAKAOAAAbQAAAPgDAOQgCAOgGAKQgGAKgJAGQgJAGgNAAIgJAAgAgIgmQgDAFAAAMQAAAVALAAQAEAAACgDIAEgHIABgIIAAgIIgCgIIgDgHQgDgDgDAAQgFAAgDAGg',
      );
    this.shape_2.setTransform(4.175, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgVBCIgIgCIAAgUQAHACAIAAQAOAAAGgLQAHgLAAgTIgBAAQgGAPgNAAQgOAAgHgMQgHgKAAgTQAAgNAEgKQAEgKAIgFQAIgGALAAQARAAAJAPQAKAOAAAbQAAAPgDAOQgCAOgGAKQgGAKgJAGQgJAGgNAAIgJAAgAgIgmQgDAFAAAMQAAAVALAAQAEAAACgDIAEgHIABgIIAAgIIgCgIIgDgHQgDgDgDAAQgFAAgDAGg',
      );
    this.shape_4.setTransform(4.175, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule18 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgaA5QgKgJAAgRQAAgKAGgJQAEgIAKgGQgIgHgEgIQgEgIAAgJQAAgPAJgIQAJgIAOAAQARAAAIAIQAJAIAAAPQgBAKgEAIQgEAIgKAGQALAGAGAIQAEAIAAALQAAAQgJAKQgKAJgRAAQgRAAgJgJgAgKATQgCAFAAAHQAAAHADAEQADAFAGAAQAHAAADgFQAEgEAAgHQAAgFgDgFQgDgFgGgFIgCgCQgGAFgEAFgAgHgqQgCADAAAHQAAAFACAFQADAEAEAEQAGgFACgEQADgEAAgFQAAgHgDgDQgDgEgFAAQgDAAgEAEg',
      );
    this.shape_2.setTransform(4.2, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgaA5QgKgJAAgRQAAgKAGgJQAEgIAKgGQgIgHgEgIQgEgIAAgJQAAgPAJgIQAJgIAOAAQARAAAIAIQAJAIAAAPQgBAKgEAIQgEAIgKAGQALAGAGAIQAEAIAAALQAAAQgJAKQgKAJgRAAQgRAAgJgJgAgKATQgCAFAAAHQAAAHADAEQADAFAGAAQAHAAADgFQAEgEAAgHQAAgFgDgFQgDgFgGgFIgCgCQgGAFgEAFgAgHgqQgCADAAAHQAAAFACAFQADAEAEAEQAGgFACgEQADgEAAgFQAAgHgDgDQgDgEgFAAQgDAAgEAEg',
      );
    this.shape_4.setTransform(4.2, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule17 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p('AgaBAIAlhqIguAAIAAgVIBHAAIAAAQIgkBvg');
    this.shape_2.setTransform(4.2, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p('AgaBAIAlhqIguAAIAAgVIBHAAIAAAQIgkBvg');
    this.shape_4.setTransform(4.2, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule16 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgZAzQgKgPAAgaQAAgPACgOQADgOAGgKQAFgKAKgGQAIgGAOAAQAJAAAHACIAAAUIgHgBIgHgBQgNAAgHAKQgGAKgBAVIAAAAQAHgPANAAQANAAAIAMQAHAKAAATQAAANgEAKQgFAKgHAFQgHAGgMAAQgQAAgKgPgAgHAGQgEAFAAAIQAAAGACAGQABAGADAEQACAEAEAAQAEAAAEgGQACgFABgMQAAgVgLAAQgFAAgDAFg',
      );
    this.shape_2.setTransform(4.25, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgZAzQgKgPAAgaQAAgPACgOQADgOAGgKQAFgKAKgGQAIgGAOAAQAJAAAHACIAAAUIgHgBIgHgBQgNAAgHAKQgGAKgBAVIAAAAQAHgPANAAQANAAAIAMQAHAKAAATQAAANgEAKQgFAKgHAFQgHAGgMAAQgQAAgKgPgAgHAGQgEAFAAAIQAAAGACAGQABAGADAEQACAEAEAAQAEAAAEgGQACgFABgMQAAgVgLAAQgFAAgDAFg',
      );
    this.shape_4.setTransform(4.25, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule15 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AghA7IAAgXQAGAEAGACQAHACAGAAQAIAAAFgGQAEgGAAgKQAAgUgRAAQgHAAgIADIgIgGIADg/IA3AAIAAAVIgiAAIgCAbIAHgCIAFAAQAJAAAHAFQAHAFAEAIQAEAJAAAMQAAAVgKALQgLAMgUAAQgPAAgLgGg',
      );
    this.shape_2.setTransform(4.275, 33.275);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AghA7IAAgXQAGAEAGACQAHACAGAAQAIAAAFgGQAEgGAAgKQAAgUgRAAQgHAAgIADIgIgGIADg/IA3AAIAAAVIgiAAIgCAbIAHgCIAFAAQAJAAAHAFQAHAFAEAIQAEAJAAAMQAAAVgKALQgLAMgUAAQgPAAgLgGg',
      );
    this.shape_4.setTransform(4.275, 33.275);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule14 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AADBAIAAgaIgqAAIAAgTIAqhSIAYAAIAABSIANAAIAAATIgNAAIAAAagAAAgXIgCAHIgRAjIAWAAIAAgdIAAgGIAAgIIAAgGIgBAAIgCAHg',
      );
    this.shape_2.setTransform(4.275, 33.15);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AADBAIAAgaIgqAAIAAgTIAqhSIAYAAIAABSIANAAIAAATIgNAAIAAAagAAAgXIgCAHIgRAjIAWAAIAAgdIAAgGIAAgIIAAgGIgBAAIgCAHg',
      );
    this.shape_4.setTransform(4.275, 33.15);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule13 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgUBBQgHgCgHgDIAAgXQANAIANAAQAJAAAEgFQAFgEAAgJQAAgKgGgEQgFgFgMAAIgHAAIAAgTIAHAAQALAAAFgFQAGgFAAgJQAAgOgNAAQgGAAgFACQgFACgFAEIgJgRQAIgHAIgCQAIgDAKAAQAPAAAJAIQAJAJAAAQQAAAKgGAIQgFAIgLAEIAAAAQAYAEAAAaQAAASgLAKQgKAKgTAAQgIAAgHgBg',
      );
    this.shape_2.setTransform(4.125, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgUBBQgHgCgHgDIAAgXQANAIANAAQAJAAAEgFQAFgEAAgJQAAgKgGgEQgFgFgMAAIgHAAIAAgTIAHAAQALAAAFgFQAGgFAAgJQAAgOgNAAQgGAAgFACQgFACgFAEIgJgRQAIgHAIgCQAIgDAKAAQAPAAAJAIQAJAJAAAQQAAAKgGAIQgFAIgLAEIAAAAQAYAEAAAaQAAASgLAKQgKAKgTAAQgIAAgHgBg',
      );
    this.shape_4.setTransform(4.125, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule12 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgEgEgFAAQgFAAgFADQgEACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAFAIAAAKQAAAJgDAIQgCAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_2.setTransform(4, 33.075);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgEgEgFAAQgFAAgFADQgEACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAHAFAFAHQAFAIAAAKQAAAJgDAIQgCAHgEAIQgGAIgIALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_4.setTransform(4, 33.075);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule11 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_2.setTransform(3.65, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_4.setTransform(3.65, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule10 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgaAzQgIgQgBgjQABghAIgQQAJgQARAAQAjAAAABBQAAATgCAPQgDAPgIAJQgIAIgOAAQgRAAgJgPgAgIggQgCALAAAVQAAAXACALQACALAGAAQAGAAADgLQACgLAAgXQAAgVgCgLQgDgMgGAAQgFAAgDAMg',
      );
    this.shape_2.setTransform(4.2, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-4.8, 33.175);

    this.shape_4 = new cjs.Shape();
    this.shape_4.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgaAzQgIgQgBgjQABghAIgQQAJgQARAAQAjAAAABBQAAATgCAPQgDAPgIAJQgIAIgOAAQgRAAgJgPgAgIggQgCALAAAVQAAAXACALQACALAGAAQAGAAADgLQACgLAAgXQAAgVgCgLQgDgMgGAAQgFAAgDAMg',
      );
    this.shape_4.setTransform(4.2, 33.175);

    this.shape_5 = new cjs.Shape();
    this.shape_5.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIABgXIgEAEIgCAEIgLAMIgPgOIAigkIAVAAIAAB/g');
    this.shape_5.setTransform(-4.8, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_3 }, { t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_5 }, { t: this.shape_4 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule09 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgVBCIgIgCIAAgUQAHACAIAAQAOAAAGgLQAHgLAAgTIgBAAQgGAPgNAAQgOAAgHgMQgHgKAAgTQAAgNAEgKQAEgKAIgFQAIgGALAAQARAAAJAPQAKAOAAAbQAAAPgDAOQgCAOgGAKQgGAKgJAGQgJAGgNAAIgJAAgAgIgmQgDAFAAAMQAAAVALAAQAEAAACgDIAEgHIABgIIAAgIIgCgIIgDgHQgDgDgDAAQgFAAgDAGg',
      );
    this.shape_2.setTransform(-0.075, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgVBCIgIgCIAAgUQAHACAIAAQAOAAAGgLQAHgLAAgTIgBAAQgGAPgNAAQgOAAgHgMQgHgKAAgTQAAgNAEgKQAEgKAIgFQAIgGALAAQARAAAJAPQAKAOAAAbQAAAPgDAOQgCAOgGAKQgGAKgJAGQgJAGgNAAIgJAAgAgIgmQgDAFAAAMQAAAVALAAQAEAAACgDIAEgHIABgIIAAgIIgCgIIgDgHQgDgDgDAAQgFAAgDAGg',
      );
    this.shape_3.setTransform(-0.075, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule08 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgaA5QgJgJAAgRQAAgKAEgJQAFgIAKgGQgIgHgEgIQgEgIAAgJQAAgPAJgIQAJgIAPAAQAQAAAIAIQAJAIAAAPQAAAKgFAIQgFAIgJAGQALAGAFAIQAGAIgBALQAAAQgJAKQgKAJgQAAQgRAAgKgJgAgJATQgDAFAAAHQAAAHADAEQAEAFAFAAQAHAAADgFQADgEAAgHQAAgFgCgFQgDgFgGgFIgCgCQgHAFgCAFgAgHgqQgCADAAAHQAAAFACAFQADAEAEAEQAGgFADgEQACgEAAgFQAAgHgDgDQgDgEgEAAQgEAAgEAEg',
      );
    this.shape_2.setTransform(-0.05, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgaA5QgJgJAAgRQAAgKAEgJQAFgIAKgGQgIgHgEgIQgEgIAAgJQAAgPAJgIQAJgIAPAAQAQAAAIAIQAJAIAAAPQAAAKgFAIQgFAIgJAGQALAGAFAIQAGAIgBALQAAAQgJAKQgKAJgQAAQgRAAgKgJgAgJATQgDAFAAAHQAAAHADAEQAEAFAFAAQAHAAADgFQADgEAAgHQAAgFgCgFQgDgFgGgFIgCgCQgHAFgCAFgAgHgqQgCADAAAHQAAAFACAFQADAEAEAEQAGgFADgEQACgEAAgFQAAgHgDgDQgDgEgEAAQgEAAgEAEg',
      );
    this.shape_3.setTransform(-0.05, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule07 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p('AgaBAIAlhqIguAAIAAgVIBHAAIAAAQIgkBvg');
    this.shape_2.setTransform(-0.05, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#E6EEF4')
      .s()
      .p('AgaBAIAlhqIguAAIAAgVIBHAAIAAAQIgkBvg');
    this.shape_3.setTransform(-0.05, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule06 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgZAzQgKgPAAgaQAAgPADgOQACgOAGgKQAFgKAJgGQAJgGAOAAQAJAAAIACIAAAUIgHgBIgIgBQgOAAgFAKQgIAKAAAVIAAAAQAHgPAMAAQAOAAAIAMQAHAKAAATQAAANgEAKQgFAKgHAFQgHAGgMAAQgQAAgKgPgAgHAGQgDAFgBAIQABAGABAGQABAGADAEQADAEADAAQAEAAADgGQAEgFAAgMQgBgVgKAAQgFAAgDAFg',
      );
    this.shape_2.setTransform(0, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgZAzQgKgPAAgaQAAgPADgOQACgOAGgKQAFgKAJgGQAJgGAOAAQAJAAAIACIAAAUIgHgBIgIgBQgOAAgFAKQgIAKAAAVIAAAAQAHgPAMAAQAOAAAIAMQAHAKAAATQAAANgEAKQgFAKgHAFQgHAGgMAAQgQAAgKgPgAgHAGQgDAFgBAIQABAGABAGQABAGADAEQADAEADAAQAEAAADgGQAEgFAAgMQgBgVgKAAQgFAAgDAFg',
      );
    this.shape_3.setTransform(0, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule05 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AghA7IAAgXQAGAEAGACQAHACAGAAQAIAAAFgGQAEgGAAgKQAAgUgRAAQgHAAgIADIgIgGIADg/IA3AAIAAAVIgiAAIgCAbIAHgCIAFAAQAJAAAHAFQAHAFAEAIQAEAJAAAMQAAAVgKALQgLAMgUAAQgPAAgLgGg',
      );
    this.shape_2.setTransform(0.025, 33.275);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AghA7IAAgXQAGAEAGACQAHACAGAAQAIAAAFgGQAEgGAAgKQAAgUgRAAQgHAAgIADIgIgGIADg/IA3AAIAAAVIgiAAIgCAbIAHgCIAFAAQAJAAAHAFQAHAFAEAIQAEAJAAAMQAAAVgKALQgLAMgUAAQgPAAgLgGg',
      );
    this.shape_3.setTransform(0.025, 33.275);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule04 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AADBAIAAgaIgqAAIAAgTIAqhSIAYAAIAABSIANAAIAAATIgNAAIAAAagAAAgXIgCAHIgRAjIAWAAIAAgdIAAgGIAAgIIAAgGIgBAAIgCAHg',
      );
    this.shape_2.setTransform(0.025, 33.15);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AADBAIAAgaIgqAAIAAgTIAqhSIAYAAIAABSIANAAIAAATIgNAAIAAAagAAAgXIgCAHIgRAjIAWAAIAAgdIAAgGIAAgIIAAgGIgBAAIgCAHg',
      );
    this.shape_3.setTransform(0.025, 33.15);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule03 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgUBBQgHgCgHgDIAAgXQANAIANAAQAJAAAEgFQAFgEAAgJQAAgKgGgEQgFgFgMAAIgHAAIAAgTIAHAAQALAAAFgFQAGgFAAgJQAAgOgNAAQgGAAgFACQgFACgFAEIgJgRQAIgHAIgCQAIgDAKAAQAPAAAJAIQAJAJAAAQQAAAKgGAIQgFAIgLAEIAAAAQAYAEAAAaQAAASgLAKQgKAKgTAAQgIAAgHgBg',
      );
    this.shape_2.setTransform(-0.125, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgUBBQgHgCgHgDIAAgXQANAIANAAQAJAAAEgFQAFgEAAgJQAAgKgGgEQgFgFgMAAIgHAAIAAgTIAHAAQALAAAFgFQAGgFAAgJQAAgOgNAAQgGAAgFACQgFACgFAEIgJgRQAIgHAIgCQAIgDAKAAQAPAAAJAIQAJAJAAAQQAAAKgGAIQgFAIgLAEIAAAAQAYAEAAAaQAAASgLAKQgKAKgTAAQgIAAgHgBg',
      );
    this.shape_3.setTransform(-0.125, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule02 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgFADQgEACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAIAFAEAHQAFAIgBAKQAAAJgCAIQgBAHgGAIQgEAIgJALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_2.setTransform(-0.25, 33.075);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'AgiBBIAAgRIAZgjIALgRQAEgHACgGQABgFAAgGQAAgHgDgEQgDgEgGAAQgFAAgFADQgEACgGAHIgLgQQAIgJAIgEQAIgEAKAAQAJAAAIAEQAIAFAEAHQAFAIgBAKQAAAJgCAIQgBAHgGAIQgEAIgJALIgQAWIAAABIAoAAIAAAVg',
      );
    this.shape_3.setTransform(-0.25, 33.075);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.blueModule01 = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // timeline functions:
    this.frame_0 = function () {
      this.stop();
    };
    this.frame_1 = function () {
      this.stop();
    };
    this.frame_2 = function () {
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(
      cjs.Tween.get(this)
        .call(this.frame_0)
        .wait(1)
        .call(this.frame_1)
        .wait(1)
        .call(this.frame_2)
        .wait(1),
    );

    // dot state
    this.shape = new cjs.Shape();
    this.shape.graphics
      .f('#5DA8EF')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAjAAAaAZQAZAaAAAiQAAAjgZAaQgaAZgjAAQgiAAgagZg',
      );

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics
      .f('#E6EEF4')
      .s()
      .p(
        'Ag8A9QgZgaAAgjQAAgiAZgaQAagZAiAAQAkAAAZAZQAZAaAAAiQAAAjgZAaQgZAZgkAAQgiAAgagZg',
      );
    this.shape_1.setTransform(0.025, 0);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape }] })
        .to({ state: [{ t: this.shape }] }, 1)
        .to({ state: [{ t: this.shape_1 }] }, 1)
        .wait(1),
    );

    // current module
    this.instance = new lib.currentModuleIndicator();
    this.instance.setTransform(0, -1, 1, 1, 0, 0, 0, 0, -1);
    this.instance._off = true;

    this.timeline.addTween(
      cjs.Tween.get(this.instance)
        .wait(1)
        .to({ _off: false }, 0)
        .to({ _off: true }, 1)
        .wait(1),
    );

    // numbers
    this.shape_2 = new cjs.Shape();
    this.shape_2.graphics
      .f('#5DA8EF')
      .s()
      .p('AAEBAIAAhKIAAgXIgDAEIgCAEIgMAMIgOgOIAigkIAVAAIAAB/g');
    this.shape_2.setTransform(-0.6, 33.175);

    this.shape_3 = new cjs.Shape();
    this.shape_3.graphics
      .f('#E6EEF4')
      .s()
      .p('AAEBAIAAhKIAAgXIgDAEIgCAEIgMAMIgOgOIAigkIAVAAIAAB/g');
    this.shape_3.setTransform(-0.6, 33.175);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({ state: [{ t: this.shape_2 }] })
        .to({ state: [{ t: this.shape_2 }] }, 1)
        .to({ state: [{ t: this.shape_3 }] }, 1)
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = p = new cjs.MovieClip();
  p.nominalBounds = new cjs.Rectangle(-17.2, -19.2, 34.5, 66.5);

  (lib.add = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // Layer 1
    this.AddStage21 = new lib.blueModule21();
    this.AddStage21.name = 'AddStage21';
    this.AddStage21.setTransform(728, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage20 = new lib.milestoneModule20();
    this.AddStage20.name = 'AddStage20';
    this.AddStage20.setTransform(692.5, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.AddStage19 = new lib.blueModule19();
    this.AddStage19.name = 'AddStage19';
    this.AddStage19.setTransform(656.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage18 = new lib.redModule18();
    this.AddStage18.name = 'AddStage18';
    this.AddStage18.setTransform(620.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage17 = new lib.blueModule17();
    this.AddStage17.name = 'AddStage17';
    this.AddStage17.setTransform(584.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage16 = new lib.redModule16();
    this.AddStage16.name = 'AddStage16';
    this.AddStage16.setTransform(548.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage15 = new lib.blueModule15();
    this.AddStage15.name = 'AddStage15';
    this.AddStage15.setTransform(512.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage14 = new lib.milestoneModule14();
    this.AddStage14.name = 'AddStage14';
    this.AddStage14.setTransform(476.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage13 = new lib.blueModule13();
    this.AddStage13.name = 'AddStage13';
    this.AddStage13.setTransform(440.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage12 = new lib.redModule12();
    this.AddStage12.name = 'AddStage12';
    this.AddStage12.setTransform(404.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage11 = new lib.blueModule11();
    this.AddStage11.name = 'AddStage11';
    this.AddStage11.setTransform(368.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage10 = new lib.milestoneModule10();
    this.AddStage10.name = 'AddStage10';
    this.AddStage10.setTransform(332.45, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.AddStage9 = new lib.blueModule09();
    this.AddStage9.name = 'AddStage9';
    this.AddStage9.setTransform(296.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage8 = new lib.redModule08();
    this.AddStage8.name = 'AddStage8';
    this.AddStage8.setTransform(260.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage7 = new lib.blueModule07();
    this.AddStage7.name = 'AddStage7';
    this.AddStage7.setTransform(224.7, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage6 = new lib.redModule06();
    this.AddStage6.name = 'AddStage6';
    this.AddStage6.setTransform(188.6, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage5 = new lib.blueModule05();
    this.AddStage5.name = 'AddStage5';
    this.AddStage5.setTransform(152.6, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage4 = new lib.redModule04();
    this.AddStage4.name = 'AddStage4';
    this.AddStage4.setTransform(116.5, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage3 = new lib.blueModule03();
    this.AddStage3.name = 'AddStage3';
    this.AddStage3.setTransform(80.6, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage2 = new lib.blueModule02();
    this.AddStage2.name = 'AddStage2';
    this.AddStage2.setTransform(44.6, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.AddStage1 = new lib.blueModule01();
    this.AddStage1.name = 'AddStage1';
    this.AddStage1.setTransform(8.6, 12.9);

    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#D2D966').ss(4).p('Eg1gAAAMBrBAAA');
    this.shape.setTransform(370.1971, 13, 1.0511, 1);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape },
            { t: this.AddStage1 },
            { t: this.AddStage2 },
            { t: this.AddStage3 },
            { t: this.AddStage4 },
            { t: this.AddStage5 },
            { t: this.AddStage6 },
            { t: this.AddStage7 },
            { t: this.AddStage8 },
            { t: this.AddStage9 },
            { t: this.AddStage10 },
            { t: this.AddStage11 },
            { t: this.AddStage12 },
            { t: this.AddStage13 },
            { t: this.AddStage14 },
            { t: this.AddStage15 },
            { t: this.AddStage16 },
            { t: this.AddStage17 },
            { t: this.AddStage18 },
            { t: this.AddStage19 },
            { t: this.AddStage20 },
            { t: this.AddStage21 },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.add,
    new cjs.Rectangle(0, 0, 738.6, 60.2),
    null,
  );

  (lib.sub = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // Layer 1
    this.SubStage26 = new lib.blueModule26();
    this.SubStage26.name = 'SubStage26';
    this.SubStage26.setTransform(781.05, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.SubStage25 = new lib.milestoneModule25();
    this.SubStage25.name = 'SubStage25';
    this.SubStage25.setTransform(749, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage24 = new lib.blueModule24();
    this.SubStage24.name = 'SubStage24';
    this.SubStage24.setTransform(718.15, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.SubStage23 = new lib.redModule23();
    this.SubStage23.name = 'SubStage23';
    this.SubStage23.setTransform(687.3, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.SubStage22 = new lib.blueModule22();
    this.SubStage22.name = 'SubStage22';
    this.SubStage22.setTransform(656.45, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.SubStage21 = new lib.redModule21();
    this.SubStage21.name = 'SubStage21';
    this.SubStage21.setTransform(625.6, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.SubStage20 = new lib.blueModule20();
    this.SubStage20.name = 'SubStage20';
    this.SubStage20.setTransform(594.75, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.SubStage19 = new lib.redModule19();
    this.SubStage19.name = 'SubStage19';
    this.SubStage19.setTransform(563.9, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage18 = new lib.blueModule18();
    this.SubStage18.name = 'SubStage18';
    this.SubStage18.setTransform(533.05, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage17 = new lib.redModule17();
    this.SubStage17.name = 'SubStage17';
    this.SubStage17.setTransform(502.2, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage16 = new lib.blueModule16();
    this.SubStage16.name = 'SubStage16';
    this.SubStage16.setTransform(471.35, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage15 = new lib.milestoneModule15();
    this.SubStage15.name = 'SubStage15';
    this.SubStage15.setTransform(440.5, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage14 = new lib.blueModule14();
    this.SubStage14.name = 'SubStage14';
    this.SubStage14.setTransform(409.65, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage13 = new lib.redModule13();
    this.SubStage13.name = 'SubStage13';
    this.SubStage13.setTransform(378.8, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage12 = new lib.blueModule12();
    this.SubStage12.name = 'SubStage12';
    this.SubStage12.setTransform(347.95, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage11 = new lib.milestoneModule11();
    this.SubStage11.name = 'SubStage11';
    this.SubStage11.setTransform(317.1, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage10 = new lib.blueModule10();
    this.SubStage10.name = 'SubStage10';
    this.SubStage10.setTransform(286.25, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.SubStage9 = new lib.redModule09();
    this.SubStage9.name = 'SubStage9';
    this.SubStage9.setTransform(255.4, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage8 = new lib.blueModule08();
    this.SubStage8.name = 'SubStage8';
    this.SubStage8.setTransform(224.55, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage7 = new lib.redModule07();
    this.SubStage7.name = 'SubStage7';
    this.SubStage7.setTransform(193.7, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage6 = new lib.blueModule06();
    this.SubStage6.name = 'SubStage6';
    this.SubStage6.setTransform(162.85, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage5 = new lib.redModule05();
    this.SubStage5.name = 'SubStage5';
    this.SubStage5.setTransform(132, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage4 = new lib.blueModule04();
    this.SubStage4.name = 'SubStage4';
    this.SubStage4.setTransform(101.15, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage3 = new lib.redModule03();
    this.SubStage3.name = 'SubStage3';
    this.SubStage3.setTransform(70.3, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage2 = new lib.blueModule02();
    this.SubStage2.name = 'SubStage2';
    this.SubStage2.setTransform(39.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.SubStage1 = new lib.blueModule01();
    this.SubStage1.name = 'SubStage1';
    this.SubStage1.setTransform(8.6, 12.9);

    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#D2D966').ss(4).p('Eg1gAAAMBrBAAA');
    this.shape.setTransform(397.6866, 13, 1.1313, 1);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape },
            { t: this.SubStage1 },
            { t: this.SubStage2 },
            { t: this.SubStage3 },
            { t: this.SubStage4 },
            { t: this.SubStage5 },
            { t: this.SubStage6 },
            { t: this.SubStage7 },
            { t: this.SubStage8 },
            { t: this.SubStage9 },
            { t: this.SubStage10 },
            { t: this.SubStage11 },
            { t: this.SubStage12 },
            { t: this.SubStage13 },
            { t: this.SubStage14 },
            { t: this.SubStage15 },
            { t: this.SubStage16 },
            { t: this.SubStage17 },
            { t: this.SubStage18 },
            { t: this.SubStage19 },
            { t: this.SubStage20 },
            { t: this.SubStage21 },
            { t: this.SubStage22 },
            { t: this.SubStage23 },
            { t: this.SubStage24 },
            { t: this.SubStage25 },
            { t: this.SubStage26 },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.sub,
    new cjs.Rectangle(0, 0, 791.6, 60.2),
    null,
  );

  (lib.mul = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    // Layer 1
    this.MulStage21 = new lib.blueModule21();
    this.MulStage21.name = 'MulStage21';
    this.MulStage21.setTransform(728, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage20 = new lib.milestoneModule20();
    this.MulStage20.name = 'MulStage20';
    this.MulStage20.setTransform(692.5, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.MulStage19 = new lib.blueModule19();
    this.MulStage19.name = 'MulStage19';
    this.MulStage19.setTransform(656.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage18 = new lib.redModule18();
    this.MulStage18.name = 'MulStage18';
    this.MulStage18.setTransform(620.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage17 = new lib.blueModule17();
    this.MulStage17.name = 'MulStage17';
    this.MulStage17.setTransform(584.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage16 = new lib.redModule16();
    this.MulStage16.name = 'MulStage16';
    this.MulStage16.setTransform(548.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage15 = new lib.blueModule15();
    this.MulStage15.name = 'MulStage15';
    this.MulStage15.setTransform(512.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage14 = new lib.redModule14();
    this.MulStage14.name = 'MulStage14';
    this.MulStage14.setTransform(476.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage13 = new lib.blueModule13();
    this.MulStage13.name = 'MulStage13';
    this.MulStage13.setTransform(440.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage12 = new lib.milestoneModule12();
    this.MulStage12.name = 'MulStage12';
    this.MulStage12.setTransform(404.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage11 = new lib.blueModule11();
    this.MulStage11.name = 'MulStage11';
    this.MulStage11.setTransform(368.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage10 = new lib.milestoneModule10();
    this.MulStage10.name = 'MulStage10';
    this.MulStage10.setTransform(332.45, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.MulStage9 = new lib.redModule09();
    this.MulStage9.name = 'MulStage9';
    this.MulStage9.setTransform(296.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage8 = new lib.blueModule08();
    this.MulStage8.name = 'MulStage8';
    this.MulStage8.setTransform(260.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage7 = new lib.redModule07();
    this.MulStage7.name = 'MulStage7';
    this.MulStage7.setTransform(224.7, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage6 = new lib.blueModule06();
    this.MulStage6.name = 'MulStage6';
    this.MulStage6.setTransform(188.6, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage5 = new lib.blueModule05();
    this.MulStage5.name = 'MulStage5';
    this.MulStage5.setTransform(152.6, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage4 = new lib.redModule04();
    this.MulStage4.name = 'MulStage4';
    this.MulStage4.setTransform(116.5, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage3 = new lib.blueModule03();
    this.MulStage3.name = 'MulStage3';
    this.MulStage3.setTransform(80.6, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage2 = new lib.redModule02();
    this.MulStage2.name = 'MulStage2';
    this.MulStage2.setTransform(44.6, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.MulStage1 = new lib.blueModule01();
    this.MulStage1.name = 'MulStage1';
    this.MulStage1.setTransform(8.6, 12.9);

    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#D2D966').ss(4).p('Eg1gAAAMBrBAAA');
    this.shape.setTransform(370.1971, 13, 1.0511, 1);

    this.shape_1 = new cjs.Shape();
    this.shape_1.graphics.f().s('#D2D966').ss(4).p('Eg1gAAAMBrBAAA');
    this.shape_1.setTransform(360.1838, 13, 1.0219, 1);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape_1 },
            { t: this.shape },
            { t: this.MulStage1 },
            { t: this.MulStage2 },
            { t: this.MulStage3 },
            { t: this.MulStage4 },
            { t: this.MulStage5 },
            { t: this.MulStage6 },
            { t: this.MulStage7 },
            { t: this.MulStage8 },
            { t: this.MulStage9 },
            { t: this.MulStage10 },
            { t: this.MulStage11 },
            { t: this.MulStage12 },
            { t: this.MulStage13 },
            { t: this.MulStage14 },
            { t: this.MulStage15 },
            { t: this.MulStage16 },
            { t: this.MulStage17 },
            { t: this.MulStage18 },
            { t: this.MulStage19 },
            { t: this.MulStage20 },
            { t: this.MulStage21 },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.mul,
    new cjs.Rectangle(0, 0, 738.6, 60.2),
    null,
  );

  (lib.div = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // Layer 1
    this.DivStage21 = new lib.blueModule21();
    this.DivStage21.name = 'DivStage21';
    this.DivStage21.setTransform(728, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage20 = new lib.milestoneModule20();
    this.DivStage20.name = 'DivStage20';
    this.DivStage20.setTransform(692.5, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.DivStage19 = new lib.blueModule19();
    this.DivStage19.name = 'DivStage19';
    this.DivStage19.setTransform(656.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage18 = new lib.redModule18();
    this.DivStage18.name = 'DivStage18';
    this.DivStage18.setTransform(620.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage17 = new lib.blueModule17();
    this.DivStage17.name = 'DivStage17';
    this.DivStage17.setTransform(584.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage16 = new lib.redModule16();
    this.DivStage16.name = 'DivStage16';
    this.DivStage16.setTransform(548.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage15 = new lib.blueModule15();
    this.DivStage15.name = 'DivStage15';
    this.DivStage15.setTransform(512.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage14 = new lib.redModule14();
    this.DivStage14.name = 'DivStage14';
    this.DivStage14.setTransform(476.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage13 = new lib.blueModule13();
    this.DivStage13.name = 'DivStage13';
    this.DivStage13.setTransform(440.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage12 = new lib.milestoneModule12();
    this.DivStage12.name = 'DivStage12';
    this.DivStage12.setTransform(404.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage11 = new lib.blueModule11();
    this.DivStage11.name = 'DivStage11';
    this.DivStage11.setTransform(368.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage10 = new lib.milestoneModule10();
    this.DivStage10.name = 'DivStage10';
    this.DivStage10.setTransform(332.45, 29.3, 1, 1, 0, 0, 0, 0, 16.4);

    this.DivStage9 = new lib.blueModule09();
    this.DivStage9.name = 'DivStage9';
    this.DivStage9.setTransform(296.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage8 = new lib.redModule08();
    this.DivStage8.name = 'DivStage8';
    this.DivStage8.setTransform(260.45, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage7 = new lib.blueModule07();
    this.DivStage7.name = 'DivStage7';
    this.DivStage7.setTransform(224.7, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage6 = new lib.redModule06();
    this.DivStage6.name = 'DivStage6';
    this.DivStage6.setTransform(188.6, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage5 = new lib.blueModule05();
    this.DivStage5.name = 'DivStage5';
    this.DivStage5.setTransform(152.6, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage4 = new lib.redModule04();
    this.DivStage4.name = 'DivStage4';
    this.DivStage4.setTransform(116.5, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage3 = new lib.redModule03();
    this.DivStage3.name = 'DivStage3';
    this.DivStage3.setTransform(80.6, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage2 = new lib.blueModule02();
    this.DivStage2.name = 'DivStage2';
    this.DivStage2.setTransform(44.6, 31.5, 1, 1, 0, 0, 0, 0, 18.6);

    this.DivStage1 = new lib.blueModule01();
    this.DivStage1.name = 'DivStage1';
    this.DivStage1.setTransform(8.6, 12.9);

    this.shape = new cjs.Shape();
    this.shape.graphics.f().s('#D2D966').ss(4).p('Eg1gAAAMBrBAAA');
    this.shape.setTransform(370.1971, 13, 1.0511, 1);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.shape },
            { t: this.DivStage1 },
            { t: this.DivStage2 },
            { t: this.DivStage3 },
            { t: this.DivStage4 },
            { t: this.DivStage5 },
            { t: this.DivStage6 },
            { t: this.DivStage7 },
            { t: this.DivStage8 },
            { t: this.DivStage9 },
            { t: this.DivStage10 },
            { t: this.DivStage11 },
            { t: this.DivStage12 },
            { t: this.DivStage13 },
            { t: this.DivStage14 },
            { t: this.DivStage15 },
            { t: this.DivStage16 },
            { t: this.DivStage17 },
            { t: this.DivStage18 },
            { t: this.DivStage19 },
            { t: this.DivStage20 },
            { t: this.DivStage21 },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.div,
    new cjs.Rectangle(0, 0, 738.6, 60.2),
    null,
  );

  (lib.sequenceLine = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // modules
    this.opDiv = new lib.div();
    this.opDiv.name = 'opDiv';
    this.opDiv.setTransform(52, 14.7, 1, 1, 0, 0, 0, 369.2, 29.4);

    this.opMul = new lib.mul();
    this.opMul.name = 'opMul';
    this.opMul.setTransform(41.15, 14.7, 1, 1, 0, 0, 0, 357.9, 29.4);

    this.opSub = new lib.sub();
    this.opSub.name = 'opSub';
    this.opSub.setTransform(48, 14.05, 1, 1, 0, 0, 0, 395.8, 29.4);

    this.opAdd = new lib.add();
    this.opAdd.name = 'opAdd';
    this.opAdd.setTransform(52, 14.05, 1, 1, 0, 0, 0, 369.2, 29.4);

    this.timeline.addTween(
      cjs.Tween.get({})
        .to({
          state: [
            { t: this.opAdd },
            { t: this.opSub },
            { t: this.opMul },
            { t: this.opDiv },
          ],
        })
        .wait(1),
    );

    this._renderFirstFrame();
  }).prototype = getMCSymbolPrototype(
    lib.sequenceLine,
    new cjs.Rectangle(-347.8, -15.3, 791.6, 60.8),
    null,
  );

  // stage content:
  (lib.VIFSequenceLine = function (mode, startPosition, loop, reversed) {
    if (loop == null) {
      loop = true;
    }
    if (reversed == null) {
      reversed = false;
    }
    var props = new Object();
    props.mode = mode;
    props.startPosition = startPosition;
    props.labels = {};
    props.loop = loop;
    props.reversed = reversed;
    cjs.MovieClip.apply(this, [props]);

    this.actionFrames = [0];
    this.isSingleFrame = false;
    // timeline functions:
    this.frame_0 = function () {
      if (this.isSingleFrame) {
        return;
      }
      if (this.totalFrames == 1) {
        this.isSingleFrame = true;
      }
      this.stop();
    };

    // actions tween:
    this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

    // Layer 2
    this.sequenceLine = new lib.sequenceLine();
    this.sequenceLine.name = 'sequenceLine';
    this.sequenceLine.setTransform(361, 37.4, 1, 1, 0, 0, 0, 0, 16.4);

    this.timeline.addTween(cjs.Tween.get(this.sequenceLine).wait(1));

    this._renderFirstFrame();
  }).prototype = p = new lib.AnMovieClip();
  p.nominalBounds = new cjs.Rectangle(
    425.7,
    43.2,
    379.09999999999997,
    23.299999999999997,
  );
  // library properties:
  lib.properties = {
    id: '69884CA1BB592343A6C97E45FCE89689',
    width: 825,
    height: 75,
    fps: 24,
    color: '#FFFFFF',
    opacity: 1.0,
    manifest: [],
    preloads: [],
  };

  // bootstrap callback support:

  (lib.Stage = function (canvas) {
    createjs.Stage.call(this, canvas);
  }).prototype = p = new createjs.Stage();

  p.setAutoPlay = function (autoPlay) {
    this.tickEnabled = autoPlay;
  };
  p.play = function () {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
  };
  p.stop = function (ms) {
    if (ms) this.seek(ms);
    this.tickEnabled = false;
  };
  p.seek = function (ms) {
    this.tickEnabled = true;
    this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
  };
  p.getDuration = function () {
    return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
  };

  p.getTimelinePosition = function () {
    return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
  };

  an.bootcompsLoaded = an.bootcompsLoaded || [];
  if (!an.bootstrapListeners) {
    an.bootstrapListeners = [];
  }

  an.bootstrapCallback = function (fnCallback) {
    an.bootstrapListeners.push(fnCallback);
    if (an.bootcompsLoaded.length > 0) {
      for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
        fnCallback(an.bootcompsLoaded[i]);
      }
    }
  };

  an.compositions = an.compositions || {};
  an.compositions['69884CA1BB592343A6C97E45FCE89689'] = {
    getStage: function () {
      return exportRoot.stage;
    },
    getLibrary: function () {
      return lib;
    },
    getSpriteSheet: function () {
      return ss;
    },
    getImages: function () {
      return img;
    },
  };

  an.compositionLoaded = function (id) {
    an.bootcompsLoaded.push(id);
    for (var j = 0; j < an.bootstrapListeners.length; j++) {
      an.bootstrapListeners[j](id);
    }
  };

  an.getComposition = function (id) {
    return an.compositions[id];
  };

  an.makeResponsive = function (
    isResp,
    respDim,
    isScale,
    scaleType,
    domContainers,
    stage,
  ) {
    var lastW,
      lastH,
      lastS = 1;
    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();
    function resizeCanvas() {
      var w = lib.properties.width,
        h = lib.properties.height;
      var iw = window.innerWidth,
        ih = window.innerHeight;
      var pRatio = window.devicePixelRatio || 1,
        xRatio = iw / w,
        yRatio = ih / h,
        sRatio = 1;
      if (isResp) {
        if (
          (respDim == 'width' && lastW == iw) ||
          (respDim == 'height' && lastH == ih)
        ) {
          sRatio = lastS;
        } else if (!isScale) {
          if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 1) {
          sRatio = Math.min(xRatio, yRatio);
        } else if (scaleType == 2) {
          sRatio = Math.max(xRatio, yRatio);
        }
      }
      domContainers[0].width = w * pRatio * sRatio;
      domContainers[0].height = h * pRatio * sRatio;
      domContainers.forEach(function (container) {
        container.style.width = w * sRatio + 'px';
        container.style.height = h * sRatio + 'px';
      });
      stage.scaleX = pRatio * sRatio;
      stage.scaleY = pRatio * sRatio;
      lastW = iw;
      lastH = ih;
      lastS = sRatio;
      stage.tickOnUpdate = false;
      stage.update();
      stage.tickOnUpdate = true;
    }
  };
  an.handleSoundStreamOnTick = function (event) {
    if (!event.paused) {
      var stageChild = stage.getChildAt(0);
      if (!stageChild.paused || stageChild.ignorePause) {
        stageChild.syncStreamSounds();
      }
    }
  };
  an.handleFilterCache = function (event) {
    if (!event.paused) {
      var target = event.target;
      if (target) {
        if (target.filterCacheList) {
          for (var index = 0; index < target.filterCacheList.length; index++) {
            var cacheInst = target.filterCacheList[index];
            if (
              cacheInst.startFrame <= target.currentFrame &&
              target.currentFrame <= cacheInst.endFrame
            ) {
              cacheInst.instance.cache(
                cacheInst.x,
                cacheInst.y,
                cacheInst.w,
                cacheInst.h,
              );
            }
          }
        }
      }
    }
  };
}
